import React, { memo } from 'react';
import { StoryblokAsset } from '../../../interfaces/StoryblokAsset.interface';
import { StoryblokLink } from '../../../interfaces/StoryblokLink.interface';
import CustomLink from '../../CustomLink/CustomLink';
import SbImage from '../../SbImage/SbImage';

export interface FooterLogoProps {
  image: StoryblokAsset;
  text: string;
  link: StoryblokLink;
}
const FooterLogo: React.FC<FooterLogoProps> = ({ image, text, link }) => {
  return (
    <>
      {link && (
        <CustomLink
          url={link?.cached_url}
          className="flex space-x-4 items-center"
        >
          <SbImage
            asset={image}
            options={{
              width: 67,
              height: 80,
            }}
          />
          <p className="text-text/body max-w-[130px]">{text}</p>
        </CustomLink>
      )}
    </>
  );
};

export default memo(FooterLogo);
